import Basic from './basic'

export default function (Vue) {
    Basic(Vue)
}